import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.44 7.997c0-.322.262-.584.584-.584h2.334a.583.583 0 1 1 0 1.167H7.024a.583.583 0 0 1-.583-.583"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.774 2.163a.583.583 0 0 0-.583.584v2.916c0 .322.261.584.583.584h.584v7c0 .322.26.583.583.583h10.5a.583.583 0 0 0 .583-.583v-7h.584a.583.583 0 0 0 .583-.584V2.747a.583.583 0 0 0-.583-.584zm11.084 4.084H3.524v6.416h9.334zM2.358 5.08V3.33h11.666v1.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })